import { REGISTER_AXES } from '../../lib/voice'
import type { RegisterDimensions } from '../../types/voice'

// Six register dimensions on a radar, hand-drawn SVG in skin tokens. Values are the API's; this
// component draws, it does not compute.
export function RegisterRadar({ register, compare, size = 260 }: { register: RegisterDimensions; compare?: RegisterDimensions; size?: number }) {
  const cx = size / 2
  const cy = size / 2
  const r = size * 0.36
  const n = REGISTER_AXES.length
  const point = (i: number, v: number) => {
    const angle = -Math.PI / 2 + (i * 2 * Math.PI) / n
    return [cx + Math.cos(angle) * r * v, cy + Math.sin(angle) * r * v] as const
  }
  const polygon = (dims: RegisterDimensions) =>
    REGISTER_AXES.map((a, i) => point(i, Math.max(0.03, Math.min(1, dims[a.key]))).join(',')).join(' ')

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="Register profile">
      {[0.25, 0.5, 0.75, 1].map((ring) => (
        <polygon key={ring} points={REGISTER_AXES.map((_, i) => point(i, ring).join(',')).join(' ')} fill="none" stroke="var(--line)" strokeWidth={1} />
      ))}
      {REGISTER_AXES.map((a, i) => {
        const [x, y] = point(i, 1)
        const [lx, ly] = point(i, 1.22)
        return (
          <g key={a.key}>
            <line x1={cx} y1={cy} x2={x} y2={y} stroke="var(--line)" strokeWidth={1} />
            <text x={lx} y={ly} textAnchor="middle" dominantBaseline="middle" fontSize={11} fill="var(--ink-2)">
              {a.label}
            </text>
          </g>
        )
      })}
      {compare && <polygon points={polygon(compare)} fill="var(--muted)" fillOpacity={0.12} stroke="var(--muted)" strokeWidth={1.5} strokeDasharray="4 3" />}
      <polygon points={polygon(register)} fill="var(--brand)" fillOpacity={0.22} stroke="var(--brand)" strokeWidth={2} />
      {REGISTER_AXES.map((a, i) => {
        const [x, y] = point(i, Math.max(0.03, Math.min(1, register[a.key])))
        return <circle key={a.key} cx={x} cy={y} r={3} fill="var(--brand)" />
      })}
    </svg>
  )
}
